import VariantPicker from './variant-picker-original.js';

// Fix product-page variant media: force the section-rendering request to resolve
// the exact selected variant via Shopify's `variant` URL parameter.
// This makes product.selected_or_first_available_variant and its featured_media
// follow the selected Skin Start / Skin Focus / Skin Complete variant.
const originalBuildRequestUrl = VariantPicker.prototype.buildRequestUrl;

VariantPicker.prototype.buildRequestUrl = function (selectedOption, source = null, sourceSelectedOptionsValues = []) {
  const requestUrl = originalBuildRequestUrl.call(this, selectedOption, source, sourceSelectedOptionsValues);

  if (source || !selectedOption?.dataset?.variantId) return requestUrl;

  const isOnProductPage =
    this.dataset.templateProductMatch === 'true' &&
    !selectedOption.closest('product-card') &&
    !selectedOption.closest('quick-add-dialog');

  if (!isOnProductPage) return requestUrl;

  const url = new URL(requestUrl, window.location.origin);
  url.searchParams.set('variant', selectedOption.dataset.variantId);
  return url.toString();
};

export default VariantPicker;